import React from 'react'
import { Link } from "gatsby"
import styled from '@emotion/styled';
import { green01, pcHeaderH } from '../../_style';
import Filter from '../../components/organisms/filter';
import PageMain from '../../components/organisms/pageMain';
import imgMain from '../../assets/imgs/lineup/mondahmin-peppermint/img-main.png';
import DetailMain from '../../components/organisms/lineupDetail/detailMain';
import Taste from '../../components/atoms/lineupDetail/taste';
import ProductTitle from '../../components/atoms/lineupDetail/propductTitle';
import StimulationLevel from '../../components/atoms/stimulationLevel';
import LabelGroup from '../../components/molecules/labelGroup';
import DetailMainHead from '../../components/molecules/lineupDetail/detailMainHead';
import DetailMainBody from '../../components/molecules/lineupDetail/detailMainBody';
import CategoryGroup from '../../components/molecules/lineupDetail/categoryGroup';
import Br from '../../components/atoms/br';
import DetailTexts from '../../components/molecules/lineupDetail/detailTexts';
import data from '../../assets/data/products.json';
import BuyBtn from '../../components/atoms/buyBtn';
import Btn from '../../components/atoms/btn';
import BtnBlank from '../../components/atoms/btnBlank';
import DetailBtns from '../../components/molecules/lineupDetail/detailBtns';
import DetailBanners from '../../components/molecules/lineupDetail/detailBanners';
import Banner from '../../components/atoms/banner';
import DetailFeature from '../../components/organisms/lineupDetail/detailFeature';
import ContentWidth from '../../components/organisms/contentWidth';
import DetailFeatureBox from '../../components/molecules/lineupDetail/detailFeatureBox';
import BottomBtns from '../../components/molecules/lineupDetail/bottomBtns';
import SectionLineup from '../../components/organisms/sectionLineup';
import StoreBtnGroup from '../../components/molecules/storeBtnGroup';
import StoreBtn from '../../components/atoms/storeBtn';
import DetailFeatureItem from '../../components/molecules/lineupDetail/detailFeatureItem';
import Caption from '../../components/atoms/caption';
import { Helmet } from 'react-helmet';

const filteredData = data.filter((item, index) => {
  if(item.name === "モンダミンJr. フッ素仕上げジェル グレープミックス味") return true;
});

const isNoStoreBtns = (filteredData[0].amazonUrl === "") && (filteredData[0].lohacoUrl === "") && (filteredData[0].rakutenUrl === "");

const Container = styled.div`
`
const MondahminJrJel = () => {
  return(
    <Container>
      <Helmet
        title="モンダミンJr. フッ素仕上げジェル グレープミックス味 | ラインナップ | モンダミン | アース製薬"
        meta={[
            { name: 'description', content: 'フッ素950ppm配合の高密着ジェルが歯の表面をコーティングしてフッ素を翌朝まで留める。歯の生え変わり時期の小、中学生におすすめのモンダミンJr. フッ素仕上げジェル グレープミックス味についてご紹介します。' },
            { name: 'keywords', content: 'モンダミンJrフッ素仕上げジェル,フッ素,口臭,口臭ケア,むし歯,歯周病,歯肉炎,歯周炎,オーラルケア,アース製薬' }
        ]}
      />
      <ContentWidth>
        <DetailMain imgPath={'lineup/mondahmin-jr-jel/img-main.png'}>
          <DetailMainHead>
            <ProductTitle>{filteredData[0].name}</ProductTitle>
            <LabelGroup labels={filteredData[0].label}></LabelGroup>
            <StimulationLevel level={'1'}></StimulationLevel>
            <CategoryGroup categories={[<>口臭・汚れ<Br />ネバつき予防</>, <>歯周病<Br />歯肉炎予防</>, 'むし歯予防', <>ホワイト<Br />ニング</>, '殺菌', 'ノンアルコール']}></CategoryGroup>
            <DetailTexts title={filteredData[0].description}>
              歯の生え変わり時期のお子様に。フッ素950ppm配合の高密着ジェルが歯の表面をコーティング。フッ素を翌朝まで留める。<Br />毎日使いたくなるちょっぴり大人のグレープミックス味。
            </DetailTexts>
          </DetailMainHead>
          <DetailMainBody>
            <dl>
              <dt>効果・効能：</dt>
              <dd>むし歯予防 / 歯周炎予防 / 歯肉炎予防 / 歯を白くする / 口中浄化 / 口中爽快 / 口臭予防</dd>
            </dl>
          </DetailMainBody>
          <DetailBtns isNoStoreBtns={isNoStoreBtns}>
            {!isNoStoreBtns &&
              <StoreBtnGroup>
                <StoreBtn store={'amazon'} href={filteredData[0].amazonUrl}></StoreBtn>
                <StoreBtn store={'rakuten'} href={filteredData[0].rakutenUrl}></StoreBtn>
                <StoreBtn store={'lohaco'} href={filteredData[0].lohacoUrl}></StoreBtn>
              </StoreBtnGroup>
            }
            <BtnBlank href={filteredData[0].productInfo}>製品情報サイトへ</BtnBlank>
          </DetailBtns>
        </DetailMain>
        <DetailFeature>
          <DetailFeatureItem>
            <DetailFeatureBox title={'おやすみ前のご使用で寝ている間に歯を強化し、むし歯を防ぐ'} img={'lineup/feature/img-feature-11.jpg'} alt={'おやすみ前のご使用で寝ている間に歯を強化し、むし歯を防ぐ'} isImgBorder>
              フッ素950ppm配合の高密着ジェルが歯の表面をくまなくコーティング。フッ素を翌朝まで留めるから、寝ている間に歯の表面を修復（再石灰化）・強化し、むし歯を防ぎます。<Br />殺菌成分CPC<sup>＊1</sup>、抗炎症成分GK<sub>2</sub><sup>＊2</sup>配合で、歯肉炎・歯周炎も予防します。
              <Caption>＊1 CPC ：塩化セチルピリジニウム</Caption>
              <Caption>＊2 GK<sub>2</sub>：グリチルリチン酸ジカリウム</Caption>
            </DetailFeatureBox>
            <DetailFeatureBox title={'お口をすすぎやすい低発泡・研磨剤無配合のジェルタイプ'}></DetailFeatureBox>
          </DetailFeatureItem>
        </DetailFeature>
        <BottomBtns productInfo={filteredData[0].productInfo}></BottomBtns>
      </ContentWidth>
      <SectionLineup></SectionLineup>
    </Container>
  );
}
export default MondahminJrJel
